import { format, formatISO, isDate } from 'date-fns';
import dayjs, { isDayjs } from 'dayjs';
import { useLocation } from 'react-router-dom';
import DateHelper from './DateHelper';

export const QueryBuilderHelper = {

    BuildQueryString: function (queryParams: any) {
        const searchParams = new URLSearchParams();
        const queryEntries = Object.entries(queryParams);
        for (const [key, value] of queryEntries) {
            if (value === null || value === undefined || value == "" || value?.toString()?.toLowerCase() == "all" || typeof value === "undefined") { //check if not null

            } else if (Array.isArray(value)) { //arrays
                value.forEach(value => searchParams.append(key, value.toString()))
            } else {
                searchParams.append(key, value.toString())
            }
        }

        // else if (key == 'searchString') { //search
        //     queryDictionary['searchString'] = searchString//encodeURIComponent(searchString)
        // }
        return (searchParams?.toString() ? "?" : "") + searchParams.toString();
    },
    CleanQueryDictionary: function (queryParams: any) {
        let keysForDel = [];
        let qr = { ...queryParams };
        for (const [key, value] of Object.entries(qr)) {
            if (value == '' || value == undefined || value == 'all') {
                keysForDel.push(key);
            } else if (value instanceof Date || isDayjs(value)) {
                const dt = format(value.toString(), 'yyyy-MM-dd');
                qr[key] = dt;
            }
        };

        keysForDel.forEach(key => {
            delete qr[key];
        });
        // if (qr['pageSize']) {
        //     delete qr['pageSize']
        // }

        return qr
    },
    SearchParamsFormatter: function (queryStr: {}, setSearchParams: any) {
        const str = new URLSearchParams(QueryBuilderHelper.CleanQueryDictionary(queryStr))
        if (setSearchParams) {
            setSearchParams(str);
        }
    },
    DefaultQueryFilterValue: function (queryKey: any, defaultValue: any = 'all') {
        const location = useLocation();
        const queryParams = new URLSearchParams(location.search);

        return queryParams && queryParams.get(queryKey) ? queryParams.get(queryKey) : defaultValue
    },
    DefaultSearchValue: function () {
        const location = useLocation();
        const queryParams = new URLSearchParams(location.search);

        return queryParams && queryParams.get('searchString') ? queryParams.get('searchString') : ""
    },
    DefaultPageSizeValue: function () {
        const location = useLocation();
        const queryParams: any = new URLSearchParams(location.search);
        var pg = queryParams && queryParams.get('pageSize') ? parseInt(queryParams.get('pageSize')) : 10
        return pg
    },
    DefaultPageNumValue: function () {
        const location = useLocation();
        const queryParams: any = new URLSearchParams(location.search);
        var pg = queryParams && queryParams.get('pageNumber') ? parseInt(queryParams.get('pageNumber')) : 1
        return pg
    },
    DefaultDateFilterValue: function (queryKey: any, defaultValue: any) {
        const location = useLocation();
        const queryParams: any = new URLSearchParams(location.search);

        return queryParams && queryParams.get(queryKey) && isDate(new Date(queryParams.get(queryKey))) ? new Date(queryParams.get(queryKey)) : defaultValue
    },
    DefaultSortValue: function (defaultValue: any) {
        const location = useLocation();
        const queryParams = new URLSearchParams(location.search);

        return queryParams && queryParams.get('sortBy') ? queryParams.get('sortBy') : defaultValue
    },
    DefaultOrderValue: function (defaultValue: any) {
        const location = useLocation();
        const queryParams = new URLSearchParams(location.search);

        return queryParams && queryParams.get('orderBy') ? queryParams.get('orderBy') : defaultValue
    },
}

export default QueryBuilderHelper;